export default __webpack_public_path__ + "static/media/S3.9127d724.svg";